module.exports = __webpack_public_path__ + "media/images/icon_search_btn_old-fe0dc744710bb7944062f3b8bb86b48c.png";